import {Injectable} from '@angular/core';
import {AppConfig} from '../app.config';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public userId;

  constructor(private config: AppConfig,
              private http: HttpClient) {
  }

  private userUrl = this.config.baseUrl + 'api/';
  protected setUserPassword = this.config.baseUrl + 'api/password';
  private loginWithPasswordUrl = this.config.baseUrl + 'api/login/password';
  private profileUpdateUrl = this.config.baseUrl + 'api/user/';
  private loginGoogleUrl = this.config.baseUrl + 'api/login/google';
  private loginGoogleCallBackUrl = this.config.baseUrl + 'api/callback';
  private removeProfileUrl = this.config.baseUrl + 'api/profile/remove';
  private userHasGiftUrl = this.config.baseUrl + 'api/has-gift';

  getCurrentUserInfo(): Observable<any> {
    return this.http.get(this.userUrl + 'user/', {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }

  login(user): Observable<any> {
    const options = {
      responseType: 'text',
      headers: {
        'Content-Language': localStorage.getItem('trans'),
        // Authorization: 'Bearer ' + localStorage.getItem('token'),
      }
    };
    // @ts-ignore
    return this.http.post(this.userUrl + 'login', user, options).pipe(map((response: Response) => {
      return response;
    }));
  }

  logOut(): any {
    localStorage.removeItem('token');
  }

  registerUser(user): Observable<any> {
    const options = {
      headers: {
        'Content-Language': localStorage.getItem('trans'),
      }
    };
    return this.http.post(this.userUrl + 'register', user, options).pipe(map((response: Response) => {
      return response;
    }));
  }

  sendVerificationCode(mobile): any {
    const options = {
      responseType: 'text',
      headers: {
        'Content-Language': localStorage.getItem('trans'),
      }
    };
    // @ts-ignore
    return this.http.post(this.userUrl + 'get-code', mobile, options).pipe(map((response: Response) => {
      return response;
    }));
  }

  loginWithPassword(user): Observable<any> {
    const options = {
      responseType: 'text',
      headers: {
        'Content-Language': localStorage.getItem('trans'),
      }
    };
    // @ts-ignore
    return this.http.post(this.loginWithPasswordUrl, user, options).pipe(map((response: Response) => {
      return response;
    }));
  }

  setPassword(password): Observable<any> {
    const options = {
      responseType: 'text',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Language': localStorage.getItem('trans'),
      }
    };
    // @ts-ignore
    return this.http.post(this.setUserPassword, password, options).pipe(map((response: Response) => {
      return response;
    }));
  }

  updateProfile(user): Observable<any> {
    const options = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      }
    };
    return this.http.post(this.profileUpdateUrl + localStorage.getItem('userOfId'), user, options).pipe(map((response: Response) => {
      return response;
    }));
  }

  updateProfileWithImg(user): Observable<any> {
    const options = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Language': localStorage.getItem('trans'),
      }
    };
    return this.http.post(this.profileUpdateUrl + localStorage.getItem('userOfId'), user, options).pipe(map((response: Response) => {
      return response;
    }));
  }

  loginGoogle(): Observable<any> {
    return this.http.get(this.loginGoogleUrl).pipe(map((response: Response) => {
      return response;
    }));
  }

  loginGoogleCallBack(paramN): Observable<any> {
    const options = {
      responseType: 'text',
      params: paramN
    };
    // @ts-ignore
    return this.http.get(this.loginGoogleCallBackUrl, options).pipe(map((response: Response) => {
      return response;
    }));
  }
  removeProfilePhoto(): Observable<any> {
    const options = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    };
    // @ts-ignore
    return this.http.get(this.removeProfileUrl, options).pipe(map((response: Response) => {
      return response;
    }));
  }
  userHasGift(): any{
    const options = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    };
    // @ts-ignore
    return this.http.get(this.userHasGiftUrl, options).pipe(map((response: Response) => {
      return response;
    }));
  }
}

